import React, { useState, useEffect } from 'react';
import { Vector3 } from 'three';
import styled from 'styled-components';
import { useThree } from '@react-three/fiber';
import { useProgress } from '@react-three/drei';
import { useSpring, animated } from '@react-spring/three';

interface Light {
  brightness: number;
  color: string;
  orbitalSpeed?: number;
  orbitalOffset?: number;
  position?: Vector3;
}

const AnimatedPointLight = styled(animated.pointLight)``;
const AnimatedAmbientLight = styled(animated.ambientLight)``;

const FillLight: React.FC<Light> = ({ brightness, color }) => {
  const { gl } = useThree();
  return (
    <AnimatedPointLight
      intensity={brightness}
      color={color}
      position={[2, 7, 3]}
      castShadow
      shadow-mapSize-height={gl.capabilities.maxTextureSize}
      shadow-mapSize-width={gl.capabilities.maxTextureSize}
      shadow-radius={10}
      shadow-bias={-0.00001}
    />
  );
};

const LightingRig: React.FC = () => {
  const [animationTrigger, setAnimationTrigger] = useState(false);
  const { progress } = useProgress();
  const lightingSpringConfig = { friction: 100, tension: 50 };

  // handle light fading in on load
  const { animateFillBrightness } = useSpring({
    animateFillBrightness: animationTrigger ? 3 * Math.PI : 0,
    config: lightingSpringConfig
  });
  const { animateAmbientBrightness } = useSpring({
    animateAmbientBrightness: animationTrigger ? 0.02 * Math.PI : 0,
    config: lightingSpringConfig
  });

  useEffect(() => {
    if (progress === 100) {
      setAnimationTrigger(true);
    }
  }, [setAnimationTrigger, progress]);

  return (
    <React.Fragment>
      <FillLight brightness={animateFillBrightness as unknown as number} color={'#fff'} />
      <AnimatedAmbientLight intensity={animateAmbientBrightness} />
    </React.Fragment>
  );
};

export default LightingRig;
